var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "case-animation-con" },
    [
      _c(
        "div",
        { staticClass: "rolling-box" },
        [
          _c("div", { ref: "hitline", staticClass: "hitline" }),
          _vm._l(_vm.lotteryCount, function (n, index) {
            return _c(
              "div",
              {
                key: _vm.lotteryCount + "_" + index,
                staticClass: "scroll-container",
                class: "count" + _vm.lotteryCount,
              },
              [
                _c(
                  "div",
                  {
                    ref: "scroll",
                    refInFor: true,
                    staticClass: "rolling-scroll",
                  },
                  _vm._l(
                    _vm.virtual_case_awards[index],
                    function (item, sub_index) {
                      return _c(
                        "div",
                        {
                          key: n + index + sub_index,
                          ref: "roll_item_" + index + "_" + sub_index,
                          refInFor: true,
                          staticClass: "rolling-item",
                          class: "rarity" + item.rarity,
                          attrs: { id: sub_index },
                        },
                        [
                          _c("div", { staticClass: "itemimg" }, [
                            _c("img", {
                              attrs: { src: _vm._f("imgfilter")(item.itempic) },
                            }),
                          ]),
                          _c("div", { staticClass: "item-name-con" }, [
                            _c("div", { staticClass: "item-name" }, [
                              _c("div", { staticClass: "weapon-name" }, [
                                _vm._v(
                                  _vm._s(_vm._f("GetItemName")(item.itemname))
                                ),
                              ]),
                              _c("div", { staticClass: "skin-name" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("GetItemSkinName")(item.itemname)
                                  )
                                ),
                              ]),
                            ]),
                            _c("div", { staticClass: "block" }),
                          ]),
                        ]
                      )
                    }
                  ),
                  0
                ),
              ]
            )
          }),
        ],
        2
      ),
      _c("div", { ref: "hitline", staticClass: "arrow-1" }),
      _c("div", { staticClass: "arrow-2" }),
      _c("div", { staticClass: "hitline" }),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }